<template>
  <div>
    <VipHeaderCompose />
    <div id="body">
      <div class="wrapper">
        <div class="loadingViewer" v-if="pdfLoading"></div>
        <div
          class="c-box"
          style="position: sticky; top: 0; z-index: 5"
          v-if="!pdfLoading"
        >
          <div class="c-box-content">
            <div class="pdf-op">
              <div class="title" style="width: 840px" :title="title">
                {{ title }}
              </div>
              <el-button-group class="center">
                <el-button
                  type=""
                  icon="el-icon-arrow-left"
                  @click="handlePrev"
                >
                  上一页
                </el-button>
                <el-button
                  type=""
                  @click="handleNext"
                  style="
                    border-radius: 4px;
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                  "
                >
                  下一页
                  <i class="el-icon-arrow-right el-icon--right"></i>
                </el-button>
                <div class="page-num">
                  页码：
                  <!-- <el-input v-model="page" @change="handleGoToPage"></el-input> -->
                  <el-input
                    v-model="page"
                    @keyup.enter.native="scrollToPage(page)"
                  ></el-input>
                  /
                  {{ pdf_pages }}
                </div>
                <!-- <el-button
                class="btn-pdf"
                type=""
                @click="handleDownload"
                style="
                  border-radius: 4px;
                  height: 40px;
                  vertical-align: top;
                  padding: 0 20px;
                  margin-left: 20px;
                "
              >
                <img
                  src="~@/assets/images/icon-pdf.png"
                  alt=""
                  style="margin-right: 5px; vertical-align: -3px"
                />
                下载
              </el-button> -->
              </el-button-group>
            </div>
          </div>
        </div>

        <div class="c-box pdf-box" v-if="!pdfLoading">
          <div
            :style="pdf_show_width < 1400 ? 'width: 100%;overflow: auto;' : ''"
            class="pdfViewer"
          >
            <div
              v-for="page in pdf_pages"
              :key="page"
              class="page"
              :data-page-number="page"
              :style="{ width: pdf_div_width + 'px' }"
              :id="'the_page' + page"
              ref="pdfPage"
            >
              <div
                class="canvasWrapper"
                :style="{ width: pdf_div_width + 'px' }"
                ref="pdfWrapper"
              >
                <canvas :id="'the_canvas' + page" ref="pdf"></canvas>
              </div>
              <div class="textLayer" :id="'the_textLayer' + page"></div>
            </div>
          </div>
        </div>
        <div class="pdf-bottom" v-if="this.pdf_show_width < 1400">
          <el-button-group class="right">
            <el-button type="" icon="el-icon-zoom-in" @click="scaleD"
              >放大</el-button
            >
            <el-button type="" icon="el-icon-zoom-out" @click="scaleX"
              >缩小</el-button
            >
          </el-button-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VipHeaderCompose from "@/components/headerCompose.vue";
let PDFJS = require("pdfjs-dist");
PDFJS.GlobalWorkerOptions.workerSrc = require("pdfjs-dist/build/pdf.worker.entry.js");
import { TextLayerBuilder, EventBus } from "pdfjs-dist/web/pdf_viewer";
import "pdfjs-dist/web/pdf_viewer.css";

export default {
  components: {
    VipHeaderCompose,
  },
  data() {
    return {
      id: this.$route.query.id || "",
      type: parseInt(this.$route.query.type) || 0,
      page: parseInt(this.$route.query.page) || 1,
      title: this.$route.query.title || "",
      pdf_scale: 96.0 / 72.0, //pdf放大系数
      //   pdf_show_width: 1010,
      pdf_show_width: 1400,
      pdf_pages: 0,
      pdf_div_width: 0,
      pdf_div_height: 0,
      pdfDivSizes: [],
      pdf_src: null,
      pdfLoading: false,
      scroll: 0,
      resizeTimeout: null,
    };
  },
  created() {
    if (!this.$store.state.logined) {
      this.$router.push(
        "/login?returnUrl=" +
          encodeURIComponent(this.$router.currentRoute.fullPath)
      );
      return;
    }

    let clientWidth = document.body.clientWidth;
    if (clientWidth > 1400) {
      this.pdf_show_width = 1400;
    } else {
      this.pdf_show_width = clientWidth;
    }

    this.get_pdfurl();

    window.addEventListener("scroll", this.handleScroll);
    //window.addEventListener("resize", this.handleResize);
  },
  methods: {
    handleDownload() {},
    handleResize() {
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }

      this.resizeTimeout = setTimeout(() => {
        let clientWidth = document.body.clientWidth;
        if (clientWidth > 1400) {
          this.pdf_show_width = 1400;
        } else {
          this.pdf_show_width = clientWidth;
        }

        this.get_pdfurl();
      }, 500);
    },
    handlePrev() {
      if (this.page > 1) {
        this.page--;
        this.scrollToPage(this.page);
      }
    },
    handleNext() {
      if (this.page < this.pdf_pages) {
        this.page++;
        this.scrollToPage(this.page);
      }
    },
    scaleD() {
      if (this.pdf_scale > 5) {
        return;
      }
      this.pdf_scale++;
      this.$refs.pdf.forEach((item) => {
        let widthTemp = item.style.width.split("px")[0];
        let heightTemp = item.style.height.split("px")[0];
        item.style.width =
          parseInt(widthTemp) * parseFloat(this.pdf_scale) + "px";
        item.style.height =
          parseInt(heightTemp) * parseFloat(this.pdf_scale) + "px";
      });
      this.$refs.pdfWrapper.forEach((item) => {
        let widthTemp = item.style.width.split("px")[0];
        let heightTemp = item.style.height.split("px")[0];
        item.style.width =
          parseInt(widthTemp) * parseFloat(this.pdf_scale) + "px";
        item.style.height =
          parseInt(heightTemp) * parseFloat(this.pdf_scale) + "px";
      });
      this.$refs.pdfPage.forEach((item) => {
        let widthTemp = item.style.width.split("px")[0];
        let heightTemp = item.style.height.split("px")[0];
        item.style.width =
          parseInt(widthTemp) * parseFloat(this.pdf_scale) + "px";
        item.style.height =
          parseInt(heightTemp) * parseFloat(this.pdf_scale) + "px";
      });
    },
    scaleX() {
      if (this.pdf_scale <= 96.0 / 72.0) {
        return;
      }
      this.$refs.pdf.forEach((item) => {
        let widthTemp = item.style.width.split("px")[0];
        let heightTemp = item.style.height.split("px")[0];
        item.style.width =
          parseInt(widthTemp) / parseFloat(this.pdf_scale) + "px";
        item.style.height =
          parseInt(heightTemp) / parseFloat(this.pdf_scale) + "px";
      });
      this.$refs.pdfWrapper.forEach((item) => {
        let widthTemp = item.style.width.split("px")[0];
        let heightTemp = item.style.height.split("px")[0];
        item.style.width =
          parseInt(widthTemp) / parseFloat(this.pdf_scale) + "px";
        item.style.height =
          parseInt(heightTemp) / parseFloat(this.pdf_scale) + "px";
      });
      this.$refs.pdfPage.forEach((item) => {
        let widthTemp = item.style.width.split("px")[0];
        let heightTemp = item.style.height.split("px")[0];
        item.style.width =
          parseInt(widthTemp) / parseFloat(this.pdf_scale) + "px";
        item.style.height =
          parseInt(heightTemp) / parseFloat(this.pdf_scale) + "px";
      });
      this.pdf_scale--;
    },
    get_pdfurl() {
      //获得pdf教案
      //加载本地
      this.pageShow = this.page;
      this.pdf_src = `${process.env.VUE_APP_BASE_API}/file/read-pdf?id=${this.id}&type=${this.type}`;
      //this.pdf_src = "/pdfjs-2.0.943-dist/web/compressed.tracemonkey-pldi-09.pdf";
      this._loadFile(this.pdf_src);
      return;
    },
    _loadFile(url) {
      this.pdfLoading = true;
      let parameter = {
        url: url,
        httpHeaders: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "X-Authorization": "Bearer " + localStorage.getItem("refreshToken"),
        },
        withCredentials: true,
      };
      //初始化pdf
      //let loadingTask = PDFJS.getDocument(url);
      let loadingTask = PDFJS.getDocument(parameter);
      loadingTask.promise
        .then((pdf) => {
          this.pdfDoc = pdf;
          this.pdf_pages = this.pdfDoc.numPages;
          //debugger
          this.$nextTick(() => {
            this._renderPage(1);
          });
        })
        .then(() => {
          this.pdfLoading = false;
          //window.scrollTo(0, this.pdf_div_height * this.page);
        })
        .catch((err) => {
          // console.log("read-error");
          // console.log(err);
          if (err && err.status && err.status === 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("logined");
            this.$store.commit("setLogined", false);
            this.$router.push(
              "/login?returnUrl=" +
                encodeURIComponent(this.$router.currentRoute.fullPath)
            );
          } else {
            this.$message.error("在线阅读加载失败，请稍后刷新页面重试！");
          }
        });
    },
    _renderPage(num) {
      //渲染pdf页
      const that = this;
      this.pdfDoc.getPage(num).then((page) => {
        let canvas = document.getElementById("the_canvas" + num);
        let ctx = canvas.getContext("2d");
        let dpr = window.devicePixelRatio || 1;
        let bsr =
          ctx.webkitBackingStorePixelRatio ||
          ctx.mozBackingStorePixelRatio ||
          ctx.msBackingStorePixelRatio ||
          ctx.oBackingStorePixelRatio ||
          ctx.backingStorePixelRatio ||
          1;
        let ratio = dpr / bsr;
        let viewport = page.getViewport({ scale: this.pdf_scale });
        viewport = page.getViewport({
          scale: (this.pdf_show_width / viewport.width) * this.pdf_scale,
        });

        canvas.width = viewport.width * ratio;
        canvas.height = viewport.height * ratio;

        canvas.style.width = viewport.width + "px";
        canvas.style.height = viewport.height + "px";

        that.pdf_div_width = viewport.width;
        // that.pdf_div_height = viewport.height;

        if (num === 1) {
          that.pdfDivSizes = [];
        }
        that.pdfDivSizes.push({
          num: num,
          width: viewport.width,
          height: viewport.height,
        });

        ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
        let renderContext = {
          canvasContext: ctx,
          viewport: viewport,
        };

        let renderTask = page.render(renderContext);
        renderTask.promise
          .then(() => {
            return page.getTextContent();
          })
          .then((textContent) => {
            // 创建文本图层div
            const textLayerDiv = document.getElementById("the_textLayer" + num);
            textLayerDiv.setAttribute("class", "textLayer");
            // 创建新的TextLayerBuilder实例
            var textLayer = new TextLayerBuilder({
              textLayerDiv: textLayerDiv,
              pageIndex: page.pageIndex,
              viewport: viewport,
              eventBus: new EventBus(),
            });

            textLayerDiv.style.width = viewport.width + "px";
            textLayerDiv.style.height = viewport.height + "px";

            textLayer.setTextContent(textContent);
            textLayer.render();
          });

        if (this.pdf_pages > num) {
          this._renderPage(num + 1);
        }

        if (this.type > 0) {
          this.scrollToPage(this.page);
        }
      });
    },
    renderPDF(num) {
      pdf.getPage(num).then((page) => {
        var scale = 1.5;
        var viewport = page.getViewport(scale);
        pageDiv = document.createElement("div");
        pageDiv.setAttribute("id", "page-" + (page.pageIndex + 1));
        pageDiv.setAttribute("style", "position: relative");
        container.appendChild(pageDiv);
        var canvas = document.createElement("canvas");
        pageDiv.appendChild(canvas);
        var context = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = view.width;
        var renderContext = { canvasContext: context, viewport: viewport };
        page.render(renderContext);
        page
          .render(renderContext)
          .then(() => {
            return page.getTextContent();
          })
          .then((textContent) => {
            // 创建文本图层div
            const textLayerDiv = document.getElementById("the_textLayer" + num);
            textLayerDiv.setAttribute("class", "textLayer");
            // 创建新的TextLayerBuilder实例
            var textLayer = new TextLayerBuilder({
              textLayerDiv: textLayerDiv,
              pageIndex: page.pageIndex,
              viewport: viewport,
            });
            textLayer.setTextContent(textContent);
            textLayer.render();
          });
      });
    },
    scrollToPage(page) {
      if (page <= this.pdfDivSizes.length) {
        let scrollTop = 125;
        for (let index = 0; index < page - 1; index++) {
          const item = this.pdfDivSizes[index];
          scrollTop += item.height + 30;
        }

        window.scrollTo({
          left: 0,
          top: scrollTop,
          behavior: "smooth",
        });
      }
    },
    handleScroll() {
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (this.pdfDivSizes && this.pdfDivSizes.length > 0) {
        let heightTotal = 0;
        for (let index = 0; index < this.pdfDivSizes.length; index++) {
          const item = this.pdfDivSizes[index];
          heightTotal += item.height + 30;
          if (heightTotal >= this.scroll - 120) {
            this.page = index + 1;
            break;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";

.loadingViewer {
  height: 800px;
  background: url("~@/assets/images/loading.gif") no-repeat center #fff;
}

.wrapper {
  padding: 0;
}
.c-box {
  background-color: #fff;
  box-shadow: 0 2px 16px rgba(111, 111, 111, 0.17);
  &-title {
    height: 56px;
    line-height: 56px;
    text-align: center;
    background-color: #3e9aff;
    h2 {
      font-size: $fontSizeH3;
      font-weight: normal;
      color: #fff;
    }
  }
  &-content {
    padding: 5px 35px 5px;
  }
  + .c-box {
    margin-top: 20px;
  }
}
.article-info {
  position: relative;
  min-height: 190px;
  padding: 15px 0 15px 150px;
  .title {
    margin-bottom: 5px;
    @include clips(2);
  }
  h1 {
    font-size: 20px;
    line-height: 1.5;
  }
  .pic {
    position: absolute;
    left: 0;
    top: 15px;
    .el-image {
      width: 135px;
      height: 188px;
    }
  }
  p {
    line-height: 24px;
    @include clip;
    .label {
      display: inline-block;
      position: relative;
      width: 4em;
      margin-right: 1em;
      @include justify;
      &:after {
        position: absolute;
        right: -1em;
        top: 0;
        content: "：";
      }
    }
    a {
      color: #3e9aff;
      + a {
        margin-left: 10px;
      }
    }
  }
  .op {
    margin-top: 10px;
    .el-button {
      width: 160px;
    }
  }
}
.info-item {
  @extend .article-info;
  min-height: 135px;
  padding: 15px 0 15px 115px;
  h2 {
    font-size: $fontSizeH3;
  }
  .pic {
    position: absolute;
    left: 0;
    top: 15px;
    .el-image {
      width: 100px;
      height: 135px;
    }
  }
}

.inner-title {
  font-size: $fontSizeH3;
  text-align: center;
  line-height: 40px;
  background-color: #e9f8ff;
  h3 {
    font-weight: normal;
    span {
      margin-right: 5px;
      color: #3e9aff;
    }
  }
}
.pdf-op {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  .title {
    font-size: 16px;
    @include clip;
  }
  .el-button-group {
    .el-button {
      float: none;
    }
  }
  .center {
    text-align: center;
    .page-num {
      display: inline-block;
      padding-left: 20px;
      .el-input {
        width: 50px;
        ::v-deep {
          .el-input__inner {
            text-align: center;
          }
        }
      }
    }
  }
  .right {
    text-align: right;
    .el-button {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}
.pdf-box {
  position: relative;
  min-height: 1.2904em;
  margin: 30px 0 0;
  font-size: 1011.23px;
  background-color: #f5f5f5;
  box-shadow: none;
  @media (max-width: 1440px) {
    font-size: calc(70.83333vw - 30px);
  }
  @media (max-width: 1200px) {
    font-size: 841px;
  }
  ::v-deep .el-loading-mask {
    font-size: 42px;
    box-shadow: 0 2px 16px rgba(111, 111, 111, 0.17);
  }

  .pdfViewer .page {
    margin: 0 0 30px;
    border: 0;
    box-shadow: 0 2px 16px rgba(111, 111, 111, 0.17);
    height: auto;
  }
}
.pdf-bottom {
  position: fixed;
  bottom: 20px;
  left: 50%;
  width: 200px;
  text-align: center;
  margin-left: -100px;
  .el-button {
    border-radius: 30px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.4);
    border: 1px solid rgba(0, 0, 0, 0.6);
    &:first-child {
      border-radius: 30px 0 0 30px;
    }
    &:last-child {
      border-radius: 0 30px 30px 0;
    }
  }
}

.bottom-bar {
  position: fixed;
  display: flex;
  bottom: 0;
  left: 50%;
  max-width: 1440px;
  width: 100%;
  padding: 25px 50px;
  line-height: 28px;
  transform: translateX(-50%);
  box-sizing: border-box;
  > div {
    + div {
      margin-left: 60px;
      color: #666666;
      a {
        color: #3e9aff;
        + a {
          margin-left: 20px;
        }
      }
    }
  }
  .title {
    margin-right: 10px;
    font-weight: bold;
  }
  img {
    margin-right: 5px;
    vertical-align: -3px;
  }
}
@media screen and (max-width: 768px) {
  #body > .wrapper {
    overflow: visible;
  }
  .pdf-op {
    justify-content: space-between;
    margin: 0 -20px;
    .title {
      display: none;
    }
    .el-button-group.center {
      width: 100%;
      text-align: left;
      white-space: nowrap;
      .el-button {
        padding: 5px 10px;
      }
      .page-num {
        float: right;
        .el-input {
          width: 30px;

          ::v-deep {
            .el-input__inner {
              height: 26px;
              padding: 0 5px;
              line-height: 24px;
            }
          }
        }
      }
    }
  }
  .btn-pdf {
    display: none;
  }
}
</style>
